import React from "react";
import Link from "next/link";
import classNames from "classnames";
import { PodcastIcon } from "./PodcastIcon";
import type { PodcastCardProps } from "./types";

export const PodcastCard: React.FC<PodcastCardProps> = ({
  episode,
  className,
  onInteractionStart,
}) => {
  const links: Array<{
    url: string;
    iconUrl: string;
    platformLabel: string;
    linkId: string;
  }> = [];

  if (episode.podcastItem) {
    const item = episode.podcastItem as {
      links?: Array<{
        id: string;
        url: string;
        icon?: { url?: string; alt?: string; title?: string };
      }>;
    };
    if (item.links) {
      item.links.forEach((link) => {
        const iconUrl = link.icon?.url;
        const platformLabel =
          link.icon?.alt || link.icon?.title || "Podcast platform";
        if (iconUrl) {
          links.push({
            url: link.url,
            iconUrl,
            platformLabel,
            linkId: link.id,
          });
        }
      });
    }
  }

  return (
    <div
      className={classNames("flex w-full flex-col bg-mono-05", className)}
      data-testid={`podcast-card-${episode.id}`}
    >
      <h3 className="line-clamp-2 font-recklessBold text-accent-16">
        {episode.name}
      </h3>

      <div className="mt-auto flex items-center gap-[0.2rem]">
        <span className="whitespace-nowrap text-assist-14">
          {episode.podcastLength}
        </span>

        <div className="ml-1 h-1 w-1 shrink-0 rounded-full bg-mono-30" />

        {links.length > 0 && (
          <div className="flex items-center">
            {links.map((link) => (
              <Link
                key={link.linkId}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex h-11 w-11 items-center justify-center transition-opacity duration-200 hover:opacity-80"
                aria-label={`Listen on ${link.platformLabel}`}
                onClick={() => onInteractionStart?.()}
              >
                <PodcastIcon
                  iconUrl={link.iconUrl}
                  platform={link.platformLabel}
                  className="h-6 w-6"
                  ariaLabel={`Listen on ${link.platformLabel}`}
                />
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

PodcastCard.displayName = "PodcastCard";

export default PodcastCard;
